<script>
  import solicitacaoImportacaoServico from '../servico';
  import $ from 'jquery';
  import Paginacao from '~componentes/Paginacao.vue';
  import 'select2';
  import 'select2/dist/js/i18n/pt-BR';
  import ModalProtocolos from '~componentes/ModalProtocolos.vue';
  import DatePicker from 'vue2-datepicker';
  import ModalMensagem from '~componentes/ModalMensagem.vue';
  import ModalArquivosSolicitacao from '~componentes/ModalArquivosSolicitacao.vue';
  import converterMoeda from '~js/converter-moeda';
  import ModalLiberarCancelar from '~componentes/ModalLiberarCancelar.vue';

  export default {
    components: { Paginacao, ModalProtocolos, DatePicker, ModalMensagem, ModalLiberarCancelar, ModalArquivosSolicitacao },
    data() {
      return {
        pagina: 1,
        totalRegistros: 0,
        totalPaginas: 0,
        registrosPorPagina: 0,
        solicitacoes: [],
        carregando: true,
        filtros: this.camposFiltros(),
        modalProtocolos: false,
        modalMensagem: false,
        modalArquivos: false,
        modalLiberarCancelar: false,
        solicitacaoSelecionada: null,
        salvandoLiberacao: false,
        animated: true,
        configuracao: this.$storage.configuracao(),
        usuario: this.$storage.usuario(),
      }
    },
    methods: {
      codigoImportacao(idSolicitacaoImportacao) {
        return 'MI-' + idSolicitacaoImportacao;
      },
      camposFiltros() {
        return {
          periodo: '',
          codigo: '',
          filtrado: false,
        };
      },
      limparFiltros() {
        this.filtros = this.camposFiltros();
        this.lista();
      },
      filtrar() {
        this.filtros.filtrar = true;
        this.lista();
      },
      lista(pagina = 1) {
        this.carregando = true;

        return solicitacaoImportacaoServico.lista(pagina, this.filtros)
          .then(res => {
            this.carregando = false;

            this.solicitacoes = res.body.registros;
            this.totalRegistros = res.body.totalRegistros;
            this.totalPaginas = res.body.totalPaginas;
            this.registrosPorPagina = res.body.registrosPorPagina;
          });
      },
      mostrarEsconderFiltro(e) {
        if (!$(e.target).hasClass('fa-chevron-down') && !$(e.target).hasClass('fa-chevron-up')) {
          $('.collapse-link').trigger('click');
        }
      },
      mostrarModalProtocolos(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalProtocolos = true;
      },
      modalProtocolosFechado() {
        this.animated = false;
        this.modalProtocolos = false;
        this.solicitacaoSelecionada = null;
      },
      mostrarModalMensagem(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalMensagem = true;
      },
      modalMensagensFechado() {
        this.animated = false;
        this.modalMensagem = false;
        this.solicitacaoSelecionada = null;
        this.lista(this.pagina);
      },
      mostrarModalArquivos(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalArquivos = true;
      },
      modalArquivosFechado() {
        this.animated = false;
        this.modalArquivos = false;
        this.solicitacaoSelecionada = null;
      },
      mostrarModalLiberarCancelar(solicitacao) {
        this.solicitacaoSelecionada = solicitacao;
        this.modalLiberarCancelar = true;
      },
      modalLiberarCancelarFechado() {
        this.animated = false;
        this.modalLiberarCancelar = false;
        this.solicitacaoSelecionada = null;
      },
      liberar() {
        this.salvandoLiberacao = true;

        solicitacaoImportacaoServico
          .liberar(this.solicitacaoSelecionada.idSolicitacaoImportacao)
          .then(status => {
            this.modalLiberarCancelar = false;

            if (status.liberado) {
              toastr.success(`Solicitação #${this.solicitacaoSelecionada.idSolicitacaoImportacao} liberada com sucesso.`);
            } else if (status.pendente) {
              toastr.warning(`Solicitação #${this.solicitacaoSelecionada.idSolicitacaoImportacao} está pendente não é possível liberar.`);
            } else if (status.reinserida) {
              toastr.warning(`Solicitação #${this.solicitacaoSelecionada.idSolicitacaoImportacao} está pendente de edição não é possível liberar.`);
            } else {
              toastr.warning(`Você não tem permissão para liberar solicitações para o projeto ${this.solicitacaoSelecionada.nomeProjeto}.`);
            }

            this.salvandoLiberacao = false;
            this.solicitacaoSelecionada = null;
          })
          .then(this.lista);
      },
      cancelar() {
        this.salvandoLiberacao = true;

        solicitacaoImportacaoServico
          .cancelar(this.solicitacaoSelecionada.idSolicitacaoImportacao)
          .then(status => {
            this.modalLiberarCancelar = false;

            if (status.cancelado) {
              toastr.success(`Solicitação #${this.solicitacaoSelecionada.idSolicitacaoImportacao} cancelada com sucesso.`);
            } else {
              toastr.warning(`Você não tem permissão para cancelar solicitações para o projeto ${this.solicitacaoSelecionada.nomeProjeto}.`);
            }

            this.salvandoLiberacao = false;
            this.solicitacaoSelecionada = null;
          })
          .then(this.lista);
      },
      liberadoOuCancelado(solicitacao) {
        return (solicitacao.statusLibCanc > 0);
      },
      status(solicitacao) {
        if (solicitacao.idImportacao > 0) {
            return solicitacao.statusImportacao;
        }
          
        if (solicitacao.statusLibCanc === 1) {
          return'Liberada pelo coordenador';
        } else if (solicitacao.statusLibCanc === 2) {
          return 'Cancelada pelo coordenador';
        } else if (solicitacao.statusLibCanc === 3) {
          return 'Liberada pela instituição';
        } else if (solicitacao.statusLibCanc === 4) {
          return 'Cancelada pela instituição';
        } else {
            if (solicitacao.solicitacaoReinserida > 0) {
                return 'Solicitante deve alterar';
            }
            
            return 'Aguardando liberação';
        }
      },
      labelCotacaoEstimada(cotacao) {
          return converterMoeda.paraCambio(cotacao);
      }
    },
    created() {
      if (this.$route.params.filtrosBag) 
        this.filtros = this.$route.params.filtrosBag;

      this.lista(this.pagina);
    },
    mounted() {
      this.$root.tituloDaPagina = 'Solicitação de Importação - Lista';
      this.$root.botaoAcaoTexto = 'Nova';
      this.$root.botaoAcaoIcon = 'fa-plus';
      this.$root.botaoAcaoLink = 'solicitacao-importacao-projeto.nova';

      this.$root.botaoRetrocederMostrar = false;

      const _this = this;

      if (this.$route.params.filtrosBag)
        if (this.filtros.filtrar)
          $('.ibox').removeClass('collapsed');
    },
    watch: {
      '$route': 'lista'
    },
  }
</script>

<style scoped>
    .mensagemNaoLida {
        font-size: 1.20em;
        color: #1d9d74;
        margin-right: 3px;
    }

    .solicitacao-reinserida {
        color: #e90015;
    }
</style>

<template>

  <div :class="['wrapper wrapper-content ', {'animated': animated}, $root.animacaoPadrao]">

    <modal-protocolos :mostrar="modalProtocolos"
                      :numeroProtocolo="solicitacaoSelecionada ? solicitacaoSelecionada.numeroProtocolo : ''"
                      @fechado="modalProtocolosFechado">
    </modal-protocolos>

    <modal-mensagem :mostrar="modalMensagem"
                    :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacao : ''"
                    :numero="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacaoImportacao : ''"
                    tipo="SolImportacao"
                    @fechado="modalMensagensFechado">
    </modal-mensagem>

    <modal-arquivos-solicitacao :mostrar="modalArquivos"
                                :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacaoImportacao : ''"
                                tipo="importacao"
                                :idProtocolo="solicitacaoSelecionada ? solicitacaoSelecionada.idProtocolo : ''"
                                @fechado="modalArquivosFechado">
    </modal-arquivos-solicitacao>

    <modal-liberar-cancelar :mostrar="modalLiberarCancelar"
                        :id="solicitacaoSelecionada ? solicitacaoSelecionada.idSolicitacaoImportacao : ''"
                        :salvando="salvandoLiberacao"
                        :liberando="configuracao.solCompraMsgConfirmacao ? false : true"
                        :mensagem="configuracao.solCompraMsgConfirmacao"
                        @fechado="modalLiberarCancelarFechado"
                        @liberar="liberar"
                        @cancelar="cancelar">
    </modal-liberar-cancelar>

    <div class="row">
      <div class="col-lg-12">
        <div class="ibox collapsed float-e-margins">
          <div class="ibox-title pointer" @click="mostrarEsconderFiltro">
            <h5>Filtrar lista <small class="m-l-sm">Clique para mostrar ou esconder os filtros</small></h5>

            <div class="ibox-tools">
              <span class="collapse-link">
                <i class="fa fa-chevron-up"></i>
              </span>
            </div>
          </div>
          <div class="ibox-content">

            <div class="row">
              <div class="col-xs-4">
                <div class="form-group">
                  <label class="control-label" for="codigo">Código da solicitação</label>

                  <input type="text"
                         class="form-control"
                         id="codigo"
                         v-model="filtros.codigo"
                         v-numero>
                </div>
              </div>

              <div class="col-xs-8">
                <div class="form-group">
                  <label class="control-label">Período</label>

                  <date-picker v-model="filtros.periodo"
                               input-class="form-control"
                               range
                               :editable="false"
                               lang="pt-br"
                               :confirm="true"
                               range-separator="a"
                               format="DD/MM/YYYY"
                               :shortcuts="false">
                  </date-picker>

                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-xs-12">
                <div class="form-group no-margins">
                  <button type="button" class="btn btn-primary no-margins" @click="filtrar">
                    <i class="fa fa-search"></i>
                    Filtrar
                  </button>
                  <button type="button" class="btn btn-default no-margins" @click="limparFiltros">
                    <i class="fa fa-search"></i>
                    Limpar filtros
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="ibox-footer">

            <div class="table-responsive">
              <table class="table table-bordered table-column-code table-column-action">
                <thead>
                    <tr>
                        <th v-if="!configuracao.naoUtilizarMensageria">Mensagens</th>
                        <th class="text-center">Número</th>
                        <th>Data solicitação</th>
                        <th>Nome solicitante</th>
                        <th>Projeto</th>
                        <th>Moeda</th>
                        <th>Valor total</th>
                        <th>Cotação estimada</th>
                        <th>Valor total estimado (R$)</th>
                        <th v-if="configuracao.criarProtocoloSolicitacao">Protocolo</th>
                        <th>Status</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(solicitacao, index) in solicitacoes" :class="{'solicitacao-reinserida': solicitacao.solicitacaoReinserida}">
                        <td v-if="!configuracao.naoUtilizarMensageria">
                            <div v-if="solicitacao.quantidadeNaoLida > 0">
                                <i class="fa fa-info-circle mensagemNaoLida" v-tooltip="'Leitura pendente'"></i> {{solicitacao.quantidadeNaoLida}}
                            </div>
                        </td>
                        <td class="text-center">{{ codigoImportacao(solicitacao.idSolicitacaoImportacao) || '---' }}</td>
                        <td>{{ solicitacao.dataSolicitacao | formatarData }} - {{ solicitacao.dataSolicitacao | formatarHora }}</td>
                        <td>{{ solicitacao.nomeSolicitante || '---' }}</td>
                        <td>{{ solicitacao.nomeProjeto || '---' }}</td>
                        <td>{{ solicitacao.nomeMoeda || '---' }}</td>
                        <td>{{ solicitacao.valor | formatarNumero }}</td>
                        <td>{{ labelCotacaoEstimada(solicitacao.cotacaoEstimada) }}</td>
                        <td>{{ solicitacao.valorEstimado | formatarNumero }}</td>
                        <td v-if="configuracao.criarProtocoloSolicitacao">
                            <a @click.prevent="mostrarModalProtocolos(solicitacao)" v-if="solicitacao.numeroProtocolo">{{ solicitacao.numeroProtocolo }} <i class="fa fa-external-link"></i></a>
                            <span v-if="!solicitacao.numeroProtocolo">---</span>
                        </td>
                        <td>{{ status(solicitacao) }}</td>
                        <td>

                            <router-link class="btn btn-primary btn-xs"
                                         active-class=""
                                         v-tooltip="'Relatório'"
                                         :to="{ name: 'solicitacao-importacao-projeto.relatorio', params: { id: solicitacao.idSolicitacaoImportacao , filtrosBag: filtros } }">
                                <i class="fa fa-file-text-o"></i>
                            </router-link>

                            <router-link tag="button"
                                         class="btn btn-secondary btn-xs"
                                         active-class=""
                                         v-tooltip="'Editar'"
                                         :disabled="liberadoOuCancelado(solicitacao)"
                                         :to="{ name: 'solicitacao-importacao-projeto.editar', params: { id: solicitacao.idSolicitacaoImportacao, idCript:  solicitacao.idSolicitacao } }">
                                <i class="fa fa-pencil"></i>
                            </router-link>

                            <button v-if="!configuracao.usoEmailLiberarSolicitacao"
                                    :disabled="liberadoOuCancelado(solicitacao)"
                                    class="btn btn-warning btn-xs"
                                    v-tooltip="'Liberar ou Cancelar solicitação'"
                                    @click="mostrarModalLiberarCancelar(solicitacao)">
                                <i class="fa fa-check"></i>
                            </button>

                            <button type="button"
                                    class="btn btn-info btn-xs"
                                    v-tooltip="'Listar ou adicionar arquivos da solicitação'"
                                    @click="mostrarModalArquivos(solicitacao)"
                                    v-if="configuracao.usarArquivosSolicitacaoImportacao">
                                <i class="fa fa-archive"></i>
                            </button>

                            <button type="button"
                                    class="btn btn-success btn-xs"
                                    v-tooltip="'Ler\Enviar mensagem'"
                                    @click="mostrarModalMensagem(solicitacao)"
                                    v-if="!configuracao.naoUtilizarMensageria">
                                <i class="fa fa-comment"></i>
                            </button>

                        </td>
                    </tr>
                  <tr v-show="carregando">
                    <td colspan="9">
                      <i class='fa fa-spinner fa-pulse'></i> Carregando...
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <paginacao :page-count="totalPaginas"
                       :click-handler="lista"
                       :per-page="registrosPorPagina"
                       :register-count="totalRegistros"
                       :show-counter="true">
            </paginacao>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-importacao-projeto/componentes/SolicitacaoImportacaoLista.vue